var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasFooterContent)?_c('div',{staticClass:"polycarbonate"},[_c('div',{staticClass:"polycarbonate__wrapper"},[_c('div',{staticClass:"polycarbonate__wrapper-content redactor",domProps:{"innerHTML":_vm._s(_vm.footerDescription)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }